import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=7d1540fd&scoped=true&"
import script from "./TermsConditions.vue?vue&type=script&lang=ts&"
export * from "./TermsConditions.vue?vue&type=script&lang=ts&"
import style0 from "./TermsConditions.vue?vue&type=style&index=0&id=7d1540fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1540fd",
  null
  
)

export default component.exports